import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { mq } from '../../../styles/mixins';
import Link from 'next/link';
import { THEME } from '../../../common/consts/theme';
import { rgba } from 'emotion-rgba';

export const Wrapper = styled.section`
  margin-left: 8.25rem;
  display: none;
  margin-bottom: 7.5rem;

  ${mq.xLarge(css`
    display: block;
  `)};
`;

export const Fixed = styled.div`
  padding-top: 8rem;
  top: 0;
  position: sticky;
`;

export const Title = styled.h2`
  font-family: ${({ theme }) => theme.font.questrial};
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 2rem;
  margin-top: 0;
  margin-bottom: 0.5rem;
`;

export const TopArticleWrapper = styled.div`
  display: flex;
  object-fit: cover;
  width: 29.375rem;
  margin-bottom: 1.5rem;
`;

export const TopArticleMeta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 16.875rem;
`;

export const ArticleTitle = styled(Link)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-family: ${({ theme }) => theme.font.questrial};
  font-style: normal;
  font-weight: normal;
  font-size: 1.125rem;
  line-height: 2rem;
  margin: 0;
  text-decoration: none;
  background: linear-gradient(
    22.45deg,
    ${THEME.colors.primary} 3.28%,
    ${THEME.colors.accent} 102.02%
  );
  background-clip: text;
  color: ${rgba(THEME.colors.core_black, 1)};
  transition: color 200ms ease-in-out;

  &:hover {
    color: ${rgba(THEME.colors.core_black, 0)};
  }
`;

export const ArticleAuthor = styled.p`
  color: ${THEME.colors.darker_grey};
  font-family: ${({ theme }) => theme.font.questrial};
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  margin-top: 0.5rem;
  align-self: flex-start;
`;
